import { styled } from '@linaria/react';

const DEFAULT_GRADIENT = `linear-gradient(
    180deg,
    rgba(17, 29, 46, 1) 0%,
    rgba(5, 24, 57, 1) 21%,
    rgba(10, 27, 72, 1) 41%,
    rgba(19, 46, 98, 1) 58%,
    rgba(20, 75, 126, 1) 74%,
    rgba(19, 100, 151, 1) 87%,
    rgba(19, 135, 184, 1) 100%
  )`;

export const Halo = styled.div<{ top?: number; gradient?: string }>`
  width: 100%;
  max-width: 430px;
  height: 430px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: ${({ top = 130 }) => `-${top}px`};
  z-index: -1;
  pointer-events: none;
  border-radius: 430px;
  background-image: ${({ gradient = DEFAULT_GRADIENT }) => gradient};
  filter: blur(128px);
`;
